import {
  GET_CLICK_CONVERSION_PIXELS,
  GET_CLICK_CONVERSION_PIXELS_SUCCESS,
  GET_CLICK_CONVERSION_PIXELS_ERROR,
  MODIFY_CLICK_CONVERSION_PIXELS,
  MODIFY_CLICK_CONVERSION_PIXELS_SUCCESS,
  MODIFY_CLICK_CONVERSION_PIXELS_ERROR,
  ADD_CLICK_CONVERSION_PIXEL,
  ADD_CLICK_CONVERSION_PIXEL_SUCCESS,
  ADD_CLICK_CONVERSION_PIXEL_ERROR,
  DELETE_CLICK_CONVERSION_PIXEL,
  DELETE_CLICK_CONVERSION_PIXEL_SUCCESS,
  DELETE_CLICK_CONVERSION_PIXEL_ERROR,
  GET_CLICK_CONVERSION_PIXELS_AGG_AD_GROUPS,
  GET_CLICK_CONVERSION_PIXELS_AGG_AD_GROUPS_SUCCESS,
  GET_CLICK_CONVERSION_PIXELS_AGG_AD_GROUPS_ERROR,
  GET_CLICK_CONVERSION_PIXELS_AGG_SOURCE_TYPES,
  GET_CLICK_CONVERSION_PIXELS_AGG_SOURCE_TYPES_SUCCESS,
  GET_CLICK_CONVERSION_PIXELS_AGG_SOURCE_TYPES_ERROR,
  GET_CLICK_CONVERSION_PIXELS_AGG_CAMPAIGNS,
  GET_CLICK_CONVERSION_PIXELS_AGG_CAMPAIGNS_SUCCESS,
  GET_CLICK_CONVERSION_PIXELS_AGG_CAMPAIGNS_ERROR,
  ADD_CLICK_IMPORT_CONVERSION_PIXEL,
  ADD_CLICK_IMPORT_CONVERSION_PIXEL_SUCCESS,
  ADD_CLICK_IMPORT_CONVERSION_PIXEL_ERROR,
  RESET_CLICK_CONVERSION,
  GET_CLICK_CONVERSION_LOGS,
  GET_CLICK_CONVERSION_LOGS_SUCCESS,
  GET_CLICK_CONVERSION_LOGS_ERROR,
  RESET_RELOAD_CONVERSION_LOG,
  GET_CLICK_CONVERSION_LOG_BY_ID,
  GET_CLICK_CONVERSION_LOG_BY_ID_SUCCESS,
  GET_CLICK_CONVERSION_LOG_BY_ID_ERROR,
  GET_PRESIGNED_URL,
  UPLOAD_FILE_TO_URL,
  GET_STATUS_OF_LOGS_BY_IDS,
  GET_STATUS_OF_LOGS_BY_IDS_SUCCESS,
  GET_STATUS_OF_LOGS_BY_IDS_ERROR,
  DOWNLOAD_BULK_CONVERSIONS_FILE,
  DOWNLOAD_BULK_CONVERSIONS_FILE_SUCCESS,
  DOWNLOAD_BULK_CONVERSIONS_FILE_ERROR,
  DELETE_CLICK_CONVERSION_LOG,
  DELETE_CLICK_CONVERSION_LOG_SUCCESS,
  DELETE_CLICK_CONVERSION_LOG_ERROR,
  GET_LEAD_CONVERSION_PIXELS_AGG_CAMPAIGNS,
  GET_LEAD_CONVERSION_PIXELS_AGG_CAMPAIGNS_SUCCESS,
  GET_LEAD_CONVERSION_PIXELS_AGG_CAMPAIGNS_ERROR,
  GET_CALL_CONVERSION_PIXELS_AGG_CAMPAIGNS_ERROR,
  GET_CALL_CONVERSION_PIXELS_AGG_CAMPAIGNS_SUCCESS,
  GET_CALL_CONVERSION_PIXELS_AGG_CAMPAIGNS,
  GET_LEAD_CONVERSION_PIXELS_AGG_PROFILES,
  GET_LEAD_CONVERSION_PIXELS_AGG_PROFILES_SUCCESS,
  GET_LEAD_CONVERSION_PIXELS_AGG_PROFILES_ERROR,
  GET_CALL_CONVERSION_PIXELS_AGG_PROFILES,
  GET_CALL_CONVERSION_PIXELS_AGG_PROFILES_SUCCESS,
  GET_CALL_CONVERSION_PIXELS_AGG_PROFILES_ERROR,
  GET_LEAD_CONVERSION_PIXELS_AGG_SOURCE_TYPES,
  GET_LEAD_CONVERSION_PIXELS_AGG_SOURCE_TYPES_SUCCESS,
  GET_LEAD_CONVERSION_PIXELS_AGG_SOURCE_TYPES_ERROR,
  GET_CALL_CONVERSION_PIXELS_AGG_SOURCE_TYPES,
  GET_CALL_CONVERSION_PIXELS_AGG_SOURCE_TYPES_SUCCESS,
  GET_CALL_CONVERSION_PIXELS_AGG_SOURCE_TYPES_ERROR,
  GET_CONVERSION_PIXELS_AGG_AD_GROUPS_V3,
  GET_CONVERSION_PIXELS_AGG_AD_GROUPS_V3_SUCCESS,
  GET_CONVERSION_PIXELS_AGG_AD_GROUPS_V3_ERROR,
  GET_CONVERSION_PIXELS_AGG_SOURCE_TYPES_V3,
  GET_CONVERSION_PIXELS_AGG_SOURCE_TYPES_V3_SUCCESS,
  GET_CONVERSION_PIXELS_AGG_SOURCE_TYPES_V3_ERROR,
  GET_CONVERSION_PIXELS_AGG_CAMPAIGNS_V3,
  GET_CONVERSION_PIXELS_AGG_CAMPAIGNS_V3_SUCCESS,
  GET_CONVERSION_PIXELS_AGG_CAMPAIGNS_V3_ERROR
} from "./actionTypes"

export const getClickConversionPixels = () => {
  return {
    type: GET_CLICK_CONVERSION_PIXELS
  }
}

export const getClickConversionPixelsSuccess = conversions => {
  return {
    type: GET_CLICK_CONVERSION_PIXELS_SUCCESS,
    payload: conversions,
  }
}

export const getClickConversionPixelsError = error => {
  return {
    type: GET_CLICK_CONVERSION_PIXELS_ERROR,
    payload: error,
  }
}


export const modifyClickConversionPixels = conversion_pixels => {
  return{
    type: MODIFY_CLICK_CONVERSION_PIXELS,
    payload : conversion_pixels
  }
}
export const modifyClickConversionPixelsSuccess = conversion_pixels => {
  return{
    type: MODIFY_CLICK_CONVERSION_PIXELS_SUCCESS,
    payload : conversion_pixels
  }
}
export const modifyClickConversionPixelsError = error => {
  return{
    type: MODIFY_CLICK_CONVERSION_PIXELS_ERROR,
    payload : error
  }
}


export const addClickConversionPixel = conversion_pixel => {
  return{
    type: ADD_CLICK_CONVERSION_PIXEL,
    payload : conversion_pixel
  }
}
export const addClickConversionPixelSuccess = conversion_pixel => {
  return{
    type: ADD_CLICK_CONVERSION_PIXEL_SUCCESS,
    payload : conversion_pixel
  }
}
export const addClickConversionPixelError = error => {
  return{
    type: ADD_CLICK_CONVERSION_PIXEL_ERROR,
    payload : error
  }
}

export const deleteClickConversionPixel = conversion_pixel => {
  return{
    type: DELETE_CLICK_CONVERSION_PIXEL,
    payload : conversion_pixel
  }
}
export const deleteClickConversionPixelSuccess = conversion_pixel => {
  return{
    type: DELETE_CLICK_CONVERSION_PIXEL_SUCCESS,
    payload : conversion_pixel
  }
}
export const deleteClickConversionPixelError = error => {
  return{
    type: DELETE_CLICK_CONVERSION_PIXEL_ERROR,
    payload : error
  }
}

export const getConversionPixelsAggAdGroupsV3 = (payload) => {
  return {
    type: GET_CONVERSION_PIXELS_AGG_AD_GROUPS_V3,
    payload: payload
  }
}

export const getConversionPixelsAggAdGroupsV3Success = (payload) => {
  return {
    type: GET_CONVERSION_PIXELS_AGG_AD_GROUPS_V3_SUCCESS,
    payload: payload
  }
}

export const getConversionPixelsAggAdGroupsV3Error = (error) => {
  return {
    type: GET_CONVERSION_PIXELS_AGG_AD_GROUPS_V3_ERROR,
    payload: error
  }
}

export const getClickConversionPixelsAggAdGroups = (payload) => {
  return {
    type: GET_CLICK_CONVERSION_PIXELS_AGG_AD_GROUPS,
    payload: payload
  }
}

export const getClickConversionPixelsAggAdGroupsSuccess = (payload) => {
  return {
    type: GET_CLICK_CONVERSION_PIXELS_AGG_AD_GROUPS_SUCCESS,
    payload: payload
  }
}

export const getClickConversionPixelsAggAdGroupsError = (error) => {
  return {
    type: GET_CLICK_CONVERSION_PIXELS_AGG_AD_GROUPS_ERROR,
    payload: error
  }
}

export const getLeadConversionPixelsAggProfiles = (payload) => {
  return {
    type: GET_LEAD_CONVERSION_PIXELS_AGG_PROFILES,
    payload: payload
  }
}

export const getLeadConversionPixelsAggProfilesSuccess = (payload) => {
  return {
    type: GET_LEAD_CONVERSION_PIXELS_AGG_PROFILES_SUCCESS,
    payload: payload
  }
}

export const getLeadConversionPixelsAggProfilesError = (error) => {
  return {
    type: GET_LEAD_CONVERSION_PIXELS_AGG_PROFILES_ERROR,
    payload: error
  }
}

export const getCallConversionPixelsAggProfiles = (payload) => {
  return {
    type: GET_CALL_CONVERSION_PIXELS_AGG_PROFILES,
    payload: payload
  }
}

export const getCallConversionPixelsAggProfilesSuccess = (payload) => {
  return {
    type: GET_CALL_CONVERSION_PIXELS_AGG_PROFILES_SUCCESS,
    payload: payload
  }
}

export const getCallConversionPixelsAggProfilesError = (error) => {
  return {
    type: GET_CALL_CONVERSION_PIXELS_AGG_PROFILES_ERROR,
    payload: error
  }
}

export const getConversionPixelsAggSourceTypesV3 = (payload) => {
  return {
    type: GET_CONVERSION_PIXELS_AGG_SOURCE_TYPES_V3,
    payload: payload
  }
}

export const getConversionPixelsAggSourceTypesV3Success = (payload) => {
  return {
    type: GET_CONVERSION_PIXELS_AGG_SOURCE_TYPES_V3_SUCCESS,
    payload: payload
  }
}

export const getConversionPixelsAggSourceTypesV3Error = (error) => {
  return {
    type: GET_CONVERSION_PIXELS_AGG_SOURCE_TYPES_V3_ERROR,
    payload: error
  }
}


export const getClickConversionPixelsAggSourceTypes = (payload) => {
  return {
    type: GET_CLICK_CONVERSION_PIXELS_AGG_SOURCE_TYPES,
    payload: payload
  }
}

export const getClickConversionPixelsAggSourceTypesSuccess = (payload) => {
  return {
    type: GET_CLICK_CONVERSION_PIXELS_AGG_SOURCE_TYPES_SUCCESS,
    payload: payload
  }
}

export const getClickConversionPixelsAggSourceTypesError = (error) => {
  return {
    type: GET_CLICK_CONVERSION_PIXELS_AGG_SOURCE_TYPES_ERROR,
    payload: error
  }
}

export const getLeadConversionPixelsAggSourceTypes = (payload) => {
  return {
    type: GET_LEAD_CONVERSION_PIXELS_AGG_SOURCE_TYPES,
    payload: payload
  }
}

export const getLeadConversionPixelsAggSourceTypesSuccess = (payload) => {
  return {
    type: GET_LEAD_CONVERSION_PIXELS_AGG_SOURCE_TYPES_SUCCESS,
    payload: payload
  }
}

export const getLeadConversionPixelsAggSourceTypesError = (error) => {
  return {
    type: GET_LEAD_CONVERSION_PIXELS_AGG_SOURCE_TYPES_ERROR,
    payload: error
  }
}

export const getCallConversionPixelsAggSourceTypes = (payload) => {
  return {
    type: GET_CALL_CONVERSION_PIXELS_AGG_SOURCE_TYPES,
    payload: payload
  }
}

export const getCallConversionPixelsAggSourceTypesSuccess = (payload) => {
  return {
    type: GET_CALL_CONVERSION_PIXELS_AGG_SOURCE_TYPES_SUCCESS,
    payload: payload
  }
}

export const getCallConversionPixelsAggSourceTypesError = (error) => {
  return {
    type: GET_CALL_CONVERSION_PIXELS_AGG_SOURCE_TYPES_ERROR,
    payload: error
  }
}

export const getConversionPixelsAggCampaignsV3 = (payload) => {
  return {
    type: GET_CONVERSION_PIXELS_AGG_CAMPAIGNS_V3,
    payload: payload
  }
}

export const getConversionPixelsAggCampaignsV3Success = (payload) => {
  return {
    type: GET_CONVERSION_PIXELS_AGG_CAMPAIGNS_V3_SUCCESS,
    payload: payload
  }
}

export const getConversionPixelsAggCampaignsV3Error = (error) => {
  return {
    type: GET_CONVERSION_PIXELS_AGG_CAMPAIGNS_V3_ERROR,
    payload: error
  }
}

export const getClickConversionPixelsAggCampaigns = (payload) => {
  return {
    type: GET_CLICK_CONVERSION_PIXELS_AGG_CAMPAIGNS,
    payload: payload
  }
}

export const getClickConversionPixelsAggCampaignsSuccess = (payload) => {
  return {
    type: GET_CLICK_CONVERSION_PIXELS_AGG_CAMPAIGNS_SUCCESS,
    payload: payload
  }
}

export const getClickConversionPixelsAggCampaignsError = (error) => {
  return {
    type: GET_CLICK_CONVERSION_PIXELS_AGG_CAMPAIGNS_ERROR,
    payload: error
  }
}

export const getLeadConversionPixelsAggCampaigns = (payload) => {
  return {
    type: GET_LEAD_CONVERSION_PIXELS_AGG_CAMPAIGNS,
    payload: payload
  }
}

export const getLeadConversionPixelsAggCampaignsSuccess = (payload) => {
  return {
    type: GET_LEAD_CONVERSION_PIXELS_AGG_CAMPAIGNS_SUCCESS,
    payload: payload
  }
}

export const getLeadConversionPixelsAggCampaignsError = (error) => {
  return {
    type: GET_LEAD_CONVERSION_PIXELS_AGG_CAMPAIGNS_ERROR,
    payload: error
  }
}

export const getCallConversionPixelsAggCampaigns = (payload) => {
  return {
    type: GET_CALL_CONVERSION_PIXELS_AGG_CAMPAIGNS,
    payload: payload
  }
}

export const getCallConversionPixelsAggCampaignsSuccess = (payload) => {
  return {
    type: GET_CALL_CONVERSION_PIXELS_AGG_CAMPAIGNS_SUCCESS,
    payload: payload
  }
}

export const getCallConversionPixelsAggCampaignsError = (error) => {
  return {
    type: GET_CALL_CONVERSION_PIXELS_AGG_CAMPAIGNS_ERROR,
    payload: error
  }
}

export const addClickImportConversionPixel = (pixelsData) => ({
  type: ADD_CLICK_IMPORT_CONVERSION_PIXEL,
  payload: pixelsData
});

export const addClickImportConversionPixelSuccess = (pixelsData) => ({
  type: ADD_CLICK_IMPORT_CONVERSION_PIXEL_SUCCESS,
  payload: pixelsData
});

export const addClickImportConversionPixelError = (error) => ({
  type: ADD_CLICK_IMPORT_CONVERSION_PIXEL_ERROR,
  payload: error,
});

export const getClickConversionLogs = (payload) => {
  return {
    type: GET_CLICK_CONVERSION_LOGS,
    payload: payload
  }
}

export const getClickConversionLogsSuccess = (payload) => {
  return {
    type: GET_CLICK_CONVERSION_LOGS_SUCCESS,
    payload: payload
  }
}

export const getClickConversionLogsError = (error) => {
  return {
    type: GET_CLICK_CONVERSION_LOGS_ERROR,
    payload: error
  }
}

export const getClickConversionLogById = (payload) => {
  return {
    type: GET_CLICK_CONVERSION_LOG_BY_ID,
    payload: payload
  }
}

export const getClickConversionLogByIdSuccess = (payload) => {
  return {
    type: GET_CLICK_CONVERSION_LOG_BY_ID_SUCCESS,
    payload: payload
  }
}

export const getClickConversionLogByIdError = (error) => {
  return {
    type: GET_CLICK_CONVERSION_LOG_BY_ID_ERROR,
    error: error
  }
}

export const resetLastConversion = () => ({
  type: RESET_CLICK_CONVERSION
})

export const resetReloadConversionLog = () => ({
  type: RESET_RELOAD_CONVERSION_LOG
})

export const getPresignedUrlForDirectUpload = (data) => ({
  type: GET_PRESIGNED_URL,
  payload: data.pixelsData,
  history: data.history
});

export const uploadFileToUrl = (payload) => ({
  type: UPLOAD_FILE_TO_URL,
  payload: payload
})

export const getStatusOfLogsByIds = (payload) => ({
  type: GET_STATUS_OF_LOGS_BY_IDS,
  payload: payload
})

export const getStatusOfLogsByIdsSuccess = (payload) => ({
  type: GET_STATUS_OF_LOGS_BY_IDS_SUCCESS,
  payload: payload
})

export const getStatusOfLogsByIdsError = (error) => ({
  type: GET_STATUS_OF_LOGS_BY_IDS_ERROR,
  payload: error,
});

/**
 * @param {Object} payload Object with { conversion_log_id }
 */
export const downloadBulkConversionsFile = (payload) => ({
  type: DOWNLOAD_BULK_CONVERSIONS_FILE,
  payload: payload,
});

export const downloadBulkConversionsFileSuccess = (payload) => ({
  type: DOWNLOAD_BULK_CONVERSIONS_FILE_SUCCESS,
  payload: payload
})

export const downloadBulkConversionsError = (error, payload) => ({
  type: DOWNLOAD_BULK_CONVERSIONS_FILE_ERROR,
  payload: payload,
  error: error
})

export const deleteClickConversionLogs = (payload) => ({
  type: DELETE_CLICK_CONVERSION_LOG,
  payload: payload
})

export const deleteClickConversionLogsSuccess = (payload) => ({
  type: DELETE_CLICK_CONVERSION_LOG_SUCCESS,
  payload: payload
})

export const deleteClickConversionLogsError = (error) => ({
  type: DELETE_CLICK_CONVERSION_LOG_ERROR,
  payload: error,
});